<template>
  <v-container v-if="!userIsAdmin()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsAdmin()">
    <v-data-table-server
      :headers="headers"
      :items="transformedUsers"
      :items-per-page="perPage"
      :page="page"
      :loading="loading"
      :items-length="totalUsers"
      @update:items-per-page="onItemsPerPageChange"
      @update:page="onPageChange"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="usersStore.search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            @input="loadUsers"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="newItem()"
            >Nuevo Usuario</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:[`item.permiso`]="{ item }">
        <v-chip
          v-for="(perm, index) in item.permiso"
          :key="index"
          class="ma-1 smallest-text"
          small
        >
          {{ perm }}
        </v-chip>
      </template>
      <template v-slot:[`item.color`]="{ item }">
        <div
          class="color-preview"
          :style="{ backgroundColor: item.color || '#FFFFFF' }"
          :title="item.color || 'Sin color'"
        ></div>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" color="green">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)" color="red">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table-server>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import {
  SELECT_PERMISOS,
  SELECT_HOTELES,
  SELECT_PUESTOS
} from '@/utils/constants'
import { storeToRefs } from 'pinia'
import { useUsersStore } from '@/stores/usersStore'
import { userIsAdmin } from '@/utils/helpers'
import NoPermission from '@/components/common/NoPermission.vue'

const usersStore = useUsersStore()
const search = ref('')
const { users, totalUsers, page, perPage } = storeToRefs(usersStore)

const emit = defineEmits(['editItem', 'delete', 'newItem'])

const headers = ref([
  { title: 'ID', key: 'id' },
  { title: 'Usuario', key: 'usuario' },
  { title: 'Nombre', key: 'nombre' },
  { title: 'Iniciales', key: 'iniciales' },
  { title: 'Color', key: 'color', sortable: false },
  { title: 'Permiso', key: 'permiso' },
  { title: 'Acceso Hotel', key: 'hotel' },
  { title: 'Puesto', key: 'puesto' },
  {
    title: '  ',
    width: '100px',
    key: 'actions',
    sortable: false
  }
])

onMounted(async () => {
  await loadUsers()
})

const loadUsers = async () => {
  await usersStore.fetchUsers({ search: search.value })
}

const transformedUsers = computed(() => {
  return users.value.map((user) => ({
    ...user,
    permiso: user.permiso.map(
      (p) => SELECT_PERMISOS.find((perm) => perm.value === p)?.text || p
    ),
    hotel:
      SELECT_HOTELES.find((h) => h.value === user.hotel)?.text || user.hotel,
    puesto:
      SELECT_PUESTOS.find((p) => p.value === String(user.puesto))?.text ||
      user.puesto
  }))
})

const onPageChange = (newPage) => {
  usersStore.setPage(newPage)
  loadUsers()
}

const onItemsPerPageChange = (newItemsPerPage) => {
  perPage.value = newItemsPerPage
  usersStore.setRows(newItemsPerPage)
  loadUsers()
}

const editItem = (item) => {
  emit('editItem', item)
}
const newItem = () => {
  emit('newItem')
}
const deleteItem = (item) => {
  emit('delete', item.id)
}
</script>
<style>
.smallest-text {
  font-size: 13px !important;
  padding: 0px 6px !important;
  max-height: 22px;
  margin: 0px !important;
  margin-left: 4px !important;
  line-height: 12px !important;
}

.color-preview {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #ccc;
  margin: 0 auto;
}
</style>
